import { useSyncExternalStore } from "react";

import { useAuthStore } from "../stores/authStore";
import type { AuthUser } from "../types/auth";

// Memory-only observation identity. This changes no session/token/grant behavior.
let authorityRevision = 0;
useAuthStore.subscribe((state, previous) => {
  if (state.user !== previous.user || state.isAuthenticated !== previous.isAuthenticated
    || state.accessToken !== previous.accessToken || state.refreshToken !== previous.refreshToken) {
    authorityRevision += 1;
  }
});

export function useAttentionRegisterAuthority(effectiveUser?: AuthUser | null): string {
  const user = useAuthStore((state) => state.user);
  const revision = useSyncExternalStore(useAuthStore.subscribe, () => authorityRevision);
  return JSON.stringify([
    revision, user?.id, user?.type, user?.vessel_id, user?.vessel_ids, user?.vessels,
    user?.role, user?.roles, user?.form_ids, user?.process_ids,
    effectiveUser?.vessel_id, effectiveUser?.role, effectiveUser?.roles,
    effectiveUser?.form_ids, effectiveUser?.process_ids,
  ]);
}
